const fragmentTypes = {
  "__schema": {
    "types": []
  }
};

export default fragmentTypes;
